<div style="max-width: 50vw; height: 100%">
  <canvas [id]="id" style="max-width: 50vw; height: 100%"></canvas>
</div>
